import { useEffect } from 'react';
const hideSplashScreens = [];
try {
    const ExpoSplashScreen = require('expo-splash-screen');
    hideSplashScreens.push(() => {
        try {
            ExpoSplashScreen.hide();
        }
        catch (_a) {
            try {
                ExpoSplashScreen.hideAsync();
            }
            catch (_b) { }
        }
    });
}
catch (_a) {
    // No expo-splash-scree package available
}
try {
    const RNSplashScreen = require('react-native-splash-screen');
    hideSplashScreens.push(() => {
        try {
            RNSplashScreen.hide();
        }
        catch (_a) { }
    });
}
catch (_b) {
    // No react-native-splash-screen package available
}
try {
    const BootSplash = require('react-native-bootsplash');
    hideSplashScreens.push(() => {
        try {
            BootSplash.hide();
        }
        catch (_a) { }
    });
}
catch (_c) {
    // No react-native-bootsplash package available
}
export function useHideSplashScreen() {
    useEffect(() => {
        hideSplashScreens.forEach((hide) => hide());
    }, []);
}
export default useHideSplashScreen;
//# sourceMappingURL=useHideSplashScreen.js.map